import {ConnectionsChunk} from "../chunks/types/ConnectionsChunk";
import {connectionsItemChunkToConnection} from "./connectionsItemChunkToConnection";
import {Connection} from "./types/Connection";

export function connectionsChunkToConnectionArray(
  connectionsChunk: ConnectionsChunk
): Array<Connection<any, any, any>> {
  const {children = []} = connectionsChunk;
  const result: Array<Connection<any, any, any>> = [];
  for (const chunk of children) {
    const connection = connectionsItemChunkToConnection(chunk);
    if (connection) {
      result.push(connection);
    }
  }
  return result;
}
